import { useMemo } from "react";
import { useIntl } from "react-intl";
import { generatePath } from "react-router";
import { PrimeIcons } from "primereact/api";
import NavRoutes from "core/app/util/NavRoutes";
import useSmartLinkHistory from "core/shared/hooks/useSmartLinkHistory";
import ReportsMessages from "reports/intl/ReportsMessages";
import ReportsConstants from "reports/utils/ReportsConstants";
import PrimeReactConstants from "core/app/util/PrimeReactConstants";
import useDownloadDataReport from "reports/data-export/data-export-list/hooks/useDownloadDataReport";

const {
  MESSAGE_SEVERITY: { INFO },
} = PrimeReactConstants;
const { DOWNLOAD, PENCIL, PAUSE_CIRCLE, PLAY_CIRCLE } = PrimeIcons;
const { ACTIVATE, DEACTIVATE } = ReportsConstants;

const useContextMenuItems = ({
  isActive,
  id,
  reportInfo,
  toggleStatus,
  toastRef,
}) => {
  const { formatMessage } = useIntl();
  const { pop } = useSmartLinkHistory();
  const { handleExport } = useDownloadDataReport(toastRef);

  const menuItems = useMemo(() => {
    return [
      {
        command: () => {
          toastRef.current.show({
            detail: "Coming soon!",
            severity: INFO,
            summary: "Info",
          });
          return;
          // eslint-disable-next-line no-unreachable
          const { dataExportEdit } = NavRoutes.reports;
          pop(generatePath(dataExportEdit, { id }));
        },
        icon: PENCIL,
        id: "editReport",
        label: formatMessage(ReportsMessages.edit),
      },
      {
        command: () => {
          toggleStatus(isActive ? DEACTIVATE : ACTIVATE);
        },
        icon: isActive ? PAUSE_CIRCLE : PLAY_CIRCLE,
        id: "toggleStatus",
        label: isActive
          ? formatMessage(ReportsMessages.deactivate)
          : formatMessage(ReportsMessages.activate),
      },
      {
        command: () => handleExport(reportInfo),
        icon: DOWNLOAD,
        id: "exportReport",
        label: formatMessage(ReportsMessages.exportReport),
      },
    ];
  }, [
    formatMessage,
    isActive,
    id,
    pop,
    toggleStatus,
    toastRef,
    handleExport,
    reportInfo,
  ]);

  return menuItems;
};

export default useContextMenuItems;
